import { VENUE_API_ENDPOINT } from "config/constants";
import { genericGet } from "./base.api";
import { VenueList } from "types/venue";
import { isString } from "lodash";

export function getVenueList(venueUrl: string, params?: Record<string, any>): Promise<VenueList> {
  return genericGet(`${venueUrl}${VENUE_API_ENDPOINT}`, params);
}

export function getVenueFile(venueUrl: string, venueID?: string, fileName?: string): Promise<any> {
  if (venueID === "" || fileName === "")
    return Promise.resolve()
  return genericGet(`${venueUrl}${VENUE_API_ENDPOINT}/${venueID}/dataset/physical_map/latest/file/buildings/${fileName}`)
    .then((res: any) => {
      if (isString(res))
        return genericGet(res)
      return res
    })
};